export default {
  button: {
    create: 'Create Video',
    new: 'New Video',
    upload: 'Upload',
    create_folder: 'Create Folder',
  },
  tab: {
    dashboard: 'Dashboard',
    videos: 'Videos',
    library: 'Library',
    learning_path: 'Collections',
    learners: 'Learners',
    learner_group: 'Groups',
    academy: 'Academy',
    integrations: 'Integrations',
    hub: 'Knowledge Hub',
    email: 'Email Settings',
  },
  subtab: {
    academy_home: 'Analytics',
    academy_builder: 'Academy Builder',
    course_builder: 'Course Builder',
    academy_config: 'Configurations',
    academy_events: 'Training Events',
  },
  actions: {
    invite_team: 'Invite your team',
    workspace_settings: 'Workspace Settings',
    new: "What's New?"
  },
  guide: {
    title: 'Quick start guide',
    // title: 'Getting Started'
  },
  workspace: {
    switch: 'Switch Workspace',
  },
};
